module.exports = __webpack_public_path__ + "img/service-1-INTguanzhu.c9198020.png";